import {
    MUTATION_SET_USER_UPLOADS_DOCUMENTS_TYPES,
} from "./types";

export default {
    [MUTATION_SET_USER_UPLOADS_DOCUMENTS_TYPES]: (state, data) => {
        state.documentsTypes = data;
    },
};